import { Panel } from "@poseidon/ui/components/Panel";
import { Grid, TextField } from "@mui/material";
import React from "react";
import { getDate } from "@poseidon/firebase/timestamp";

export function ApplicationBasicDetailsPanel({ application }) {
  //todo: createdAt/updatedAt dont seem to exist
  return (
    <Panel expandable title="Basic Details">
      <Grid container spacing={3} mb={3}>
        <Grid
          item
          xs={12}
          sm={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
          }}
        >
          <TextField
            value={application.applicationNumber}
            label="Application Number"
            margin="none"
            disabled={true}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sm={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
          }}
        >
          <TextField
            value={getDate(application.createdDate)?.toLocaleString()}
            label="Created At"
            margin="none"
            disabled
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
          }}
        >
          <TextField
            value={application.updatedAt?.toLocaleString()}
            label="Updated At"
            margin="none"
            disabled
          />
        </Grid>
      </Grid>
    </Panel>
  );
}
